import {
  GET_BANNERS,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_FAIL,
  GET_BANNER_DETAILS,
  GET_BANNER_DETAILS_SUCCESS,
  GET_BANNER_DETAILS_FAIL,
  CREATE_BANNER,
  CREATE_BANNER_SUCCESS,
  CREATE_BANNER_FAIL,
  UPDATE_BANNER,
  UPDATE_BANNER_SUCCESS,
  UPDATE_BANNER_FAIL,
  DELETE_BANNER,
  DELETE_BANNER_SUCCESS,
  DELETE_BANNER_FAIL,
 
} from "./actionTypes"

const INIT_STATE = {

  banners: {
    banners: [],
    total: "",
    page: "",
  },
  bannerDetails: {},
  error: {},
  loading: false,
}

const Banner = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Banner - This line cannot be edited or removed
    case GET_BANNERS:
    case GET_BANNER_DETAILS:
    case CREATE_BANNER:
    case UPDATE_BANNER:
    case DELETE_BANNER:
      return {
        ...state,
        loading: true,
      }

    case DELETE_BANNER_FAIL:
    case GET_BANNERS_FAIL:
    case GET_BANNER_DETAILS_FAIL:
    case UPDATE_BANNER_FAIL:
    case CREATE_BANNER_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_BANNERS_SUCCESS:
      return {
        ...state,
        banners: action.payload,
        error: {},
        loading: false,
      }

    case GET_BANNER_DETAILS_SUCCESS:
      return {
        ...state,
        bannerDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_BANNER_SUCCESS:
      return {
        ...state,
        banners: {
          ...state.banners,
          banners: [action.payload, ...state.banners.banners],
          total: state.banners.total + 1,
        },
        bannerDetails: action.payload,
        error: {},
        loading: false,
      }

    case UPDATE_BANNER_SUCCESS:
      return {
        ...state,
        banners: {
          ...state.banners,
          banners: state.banners.banners.map(client =>
            client._id === action.payload._id
              ? { ...client, ...action.payload }
              : client
          ),
        },
        bannerDetails: action.payload,
        loading: false,
        error: {},
      }

    case DELETE_BANNER_SUCCESS:
      return {
        ...state,
        banners: {
          ...state.banners,
          banners: state.banners.banners.filter(
            client => client._id !== action.payload._id
          ),
        },
        error: {},
        loading: false,
      }

    default:
      return state
  }
}

export default Banner
